<template>
  <div class="universal-link-container">
    <div class="text-icon-container">
      <div class="icon-wrapper">
        <FriedIcon class="globe-icon" icon="globe" />
      </div>
      <div class="link-text">
        <FriedH4>{{ t('dsr_universal_link_title') }}</FriedH4>
        <FriedParagraph :size="ParagraphSize.Small">{{
          t('dsr_universal_link_description')
        }}</FriedParagraph>
      </div>
    </div>
    <FriedButton
      :button-type="ButtonType.Tertiary"
      class="copy-link-button"
      data-external="dsr-share-modal-people-list-copy-link-button"
      @click="handleCopyUniversalLink"
    >
      <template #leftIcon>
        <FriedIcon icon="link" />
      </template>
      {{ t('dsr_copy_link') }}
    </FriedButton>
  </div>
</template>

<script lang="ts">
import { ButtonType, ParagraphSize } from '@getaccept/fried-tofu';
import { useI18n } from 'vue-i18n';
import { UrlHelper } from '@getaccept/lib-shared/src/helpers/url.helper';
import { defineComponent } from 'vue';
import copy from 'copy-to-clipboard';
import { useEnvironment } from '@getaccept/lib-shared/src/composables/environment.composable';
import SelectionHelper from '../selection/selection.helper';

export default defineComponent({
  props: {
    url: {
      type: String,
      required: true,
      validator: (value: string) => UrlHelper.isValidUrl(value),
    },
  },
  setup(props) {
    const { t } = useI18n();
    const { isSandbox, isLocalHost } = useEnvironment();

    const handleCopyUniversalLink = () => {
      let newUrl = props.url;

      if (isLocalHost.value || isSandbox.value) {
        newUrl = newUrl.replace('https://app.ga-staging.com', window.location.origin);
      }

      SelectionHelper.clearSelection();
      copy(newUrl);
    };

    return {
      t,
      ButtonType,
      ParagraphSize,
      handleCopyUniversalLink,
    };
  },
});
</script>

<style lang="scss" scoped>
.universal-link-container {
  display: flex;
  margin-top: var(--spacing-150);

  .text-icon-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;

    .icon-wrapper {
      margin-right: var(--spacing-50);
      background-color: var(--gray-96);
      height: 2.5rem;
      width: 2.5rem;
      display: flex;
      justify-content: center;
      border-radius: 50%;

      .globe-icon {
        color: var(--blue-45);
      }
    }

    .link-text {
      display: flex;
      flex-direction: column;
    }
  }

  .copy-link-button {
    color: var(--blue-45);
  }
}
</style>
